import {useEffect} from 'react';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import {PageCounterStatus} from '../constant';
import {events} from '../constant/textViewerSagaEvents';
import {usePageCounterStatus} from '../hook/usePageCounterStatus.hook';
import {FrameSize} from '../type/FrameSize.interface';

export function TextViewerPageCounter({
  productId,
  size,
  isPreview,
}: {
  productId: number;
  size: FrameSize;
  isPreview?: boolean;
}) {
  const dispatch = useTypedDispatch();
  const pageCounterStatus = usePageCounterStatus({productId, size});

  useEffect(() => {
    if (pageCounterStatus === PageCounterStatus.NoCount) {
      return;
    }

    if (pageCounterStatus === PageCounterStatus.OnlyCurrentPageCount) {
      dispatch(events.currentPageCountRequired({productId, size, isPreview}));
      return;
    }

    dispatch(events.allPageCountRequired({productId, size, isPreview}));
  }, [dispatch, isPreview, pageCounterStatus, productId, size]);

  return null;
}
